import React, { useEffect } from "react";
import { Loader, ReactChildrenProps } from "ecom-teams-apps-core";
import { observer } from "mobx-react-lite";
import pl from "shared/messages/pl";
import { useStore } from "stores/Stores";
import styles from "./dictionaryProvider.module.scss";
import ErrorModal from "modals/ErrorModal";

const DictionaryProvider: React.FC<ReactChildrenProps> = observer((props: ReactChildrenProps) => {
    const { taskStatusesStore } = useStore();

    useEffect(() => {
        taskStatusesStore.loadTaskStatuses();
    }, [taskStatusesStore]);

    const renderLoader = () => {
        return (
            <div className={styles.loaderWrapper}>
                <Loader text={pl.common.appLoading} />
            </div>
        );
    };

    const renderErrorModal = () => {
        return (
            <ErrorModal
                header={pl.dictionaryProvider.loadStatusesError.header}
                message={pl.dictionaryProvider.loadStatusesError.content}
            />
        );
    };

    return !taskStatusesStore.loadTasksStatusesRequestStatus.isDone ? (
        renderLoader()
    ) : taskStatusesStore.loadTasksStatusesRequestStatus.error ? (
        renderErrorModal()
    ) : (
        <>{props.children}</>
    );
});

export default DictionaryProvider;
